import * as api from "../generated-api";
import { apiCall, apiCallWithResponse } from "../common";
import { AxiosResponse } from "axios";

export const getDealDocumentVersions = (
  orgId: number,
  dealId: number,
  dealDocumentId: number,
  successCallback?: (dealDocuments: api.DealDocumentVersion[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealDocumentVersion[]>(
    () => {
      return api.getDealDocumentVersions(orgId, dealId, dealDocumentId);
    },
    successCallback,
    errorCallback
  );
};

export const getDealDocumentContentsForVersion = (
  orgId: number,
  dealId: number,
  dealDocumentId: number,
  versionNumber: number,
  successCallback?: (dealDocuments: AxiosResponse<Blob>) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCallWithResponse(
    () => {
      return api.getDealDocumentContentsForVersion(
        orgId,
        dealId,
        dealDocumentId,
        versionNumber,
        {
          responseType: "blob",
        }
      );
    },
    successCallback,
    errorCallback
  );
};
